import { createSlice } from "@reduxjs/toolkit";

const initialProductState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    productForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const productSlice = createSlice({
    name: "products",
    initialState: initialProductState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getProductById
        productFetched: (state, action) => {
            state.actionsLoading = false;
            state.productForEdit = action.payload.productForEdit;
            state.floorPlans = action.payload.productForEdit.floorPlans;
            state.error = null;

        },
        // getProductChart
        productChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.productChart = action.payload.productChart;
            state.error = null;

        },
        // getProductChart
        productHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.productChartHour = action.payload.productChartHour;
            state.error = null;

        },
        // getProductChart
        productHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.productChartHourZone = action.payload.productChartHourZone;
            state.error = null;

        },
        // get list data
        productsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.productForEdit = undefined;
            state.floorPlans = undefined;
            state.productChart = undefined;
            state.productChartHour = undefined;
            state.productChartHourZone = undefined;
        },
        // createProduct
        productCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateProduct
        productUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // productDeleted
        productDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
